// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/vatepay-md-menu-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VatepayCrad_main_container{
    background-color: #2F4604;
    /* padding: 0 50px; */
}
.VatepayLTDCrad_partnershipbgImg_container{
    position: absolute;
    right: 0;
}

.VatepayCrad_container{
    display: grid;
    grid-template-columns: repeat(10,1fr);
    gap: 30px;
    padding: 160px 50px;
    overflow: scroll;
    scrollbar-width: none;
}
  
.VatepayCrad_container::-webkit-scrollbar {
    width: 0;
}
  
.VatepayCrad_container::-webkit-scrollbar-thumb {
    background-color: transparent;
}

.mdVatepayCrad{
    background: linear-gradient(180deg, #012D01 65%, #EAAD11 130%);
    width: 367px;
    height: 356px;
    border-radius: 15px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.mdVatepayCrad_menu_container{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    width: 80px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -10px;
    right: -3px;
}

.vatepaycardmenu_img{
    height: 28px;
    width: 28px;
}

.mdVatepayCrad_img{
    padding: 20px 0;
}

.mdVatepayCrad_img img{
    width: 69px;
    height: 69px;
    border-radius: 100%;
    object-fit: cover;
}

.mdVatepayCrad_column2{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.mdVatepayCradh3{
    font-weight: 700;
    font-size: 16px;
    line-height: 24.46px;
    /* width: 188px; */
    height: 24px;
    padding-bottom: 5px;
    
}

.mdVatepayCradh5{
    width: 100px;
    height: 21px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21.41px;
    color: #5CBF14;
    padding-bottom: 50px;
}

.vatepay3_star{
    width: 132px;
    height: 20px;
    padding-bottom: 50px;
}

.mdVatepayCradp{
    width: 235px;
    height: 84px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21.41px;
}


/* responsiveness starts here */
@media screen and (max-width: 900px){
    
    .mdVatepayCrad_menu_container{
        width: 50px;
        height: 50px;
        
    }
    
    .vatepaycardmenu_img{
        height: 23px;
        width: 23px;
    }
    
    .mdVatepayCrad_img img{
        width: 69px;
        height: 69px;
        border-radius: 69px;
    }
    
    .mdVatepayCradh3{
        font-size: 14px;
        
    }
    
    .mdVatepayCradh5{
        font-size: 12px;
    }
    
    .vatepay3_star{
        width: 130px;
        height: 20px;
        padding-bottom: 50px;
    }
    
    .mdVatepayCradp{
        width: 180px;
        font-size: 10px;
    }
    
}

@media screen and (max-width: 500px){
    .VatepayCrad_main_container{
        background-color: #2F4604;
        padding: 0 20px;
    }
    
    .VatepayCrad_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;
        padding: 60px 20px;
    }
    
    .mdVatepayCrad{
        background: linear-gradient(180deg, #012D01 65%, #EAAD11 130%);
        width: 100%;
        height: 356px;
        border-radius: 15px;
        text-align: center;
        position: relative;
        overflow: hidden;
    
    }
    
    .mdVatepayCrad_menu_container{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-position: center;
        background-repeat: no-repeat;
        width: 80px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -10px;
        right: -3px;
        
    }
    
    .vatepaycardmenu_img{
        height: 28px;
        width: 28px;
    }
    
    .mdVatepayCrad_img{
        padding: 20px 0;
    }
    
    .mdVatepayCrad_column2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    
    .mdVatepayCradh3{
        font-weight: 700;
        font-size: 16px;
        line-height: 24.46px;
        /* width: 188px; */
        height: 24px;
        padding-bottom: 5px;
        
    }
    
    .mdVatepayCradh5{
        width: 100px;
        height: 21px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21.41px;
        color: #5CBF14;
        padding-bottom: 50px;
    }
    
    .vatepay3_star{
        width: 132px;
        height: 20px;
        padding-bottom: 50px;
    }
    
    .mdVatepayCradp{
        width: 235px;
        height: 84px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21.41px;
    }


}

@media screen and (max-width: 330px){
      
    .mdVatepayCradh3{
        font-size: 14px;
    }
    
    .mdVatepayCradh5{
        font-size: 12px;
    }
    
    .mdVatepayCradp{
        width: 210px;
        font-size: 12px;
    }


}`, "",{"version":3,"sources":["webpack://./src/styles/VatepayLTDCrad.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8DAA8D;IAC9D,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yDAAgE;IAChE,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;;AAGA,+BAA+B;AAC/B;;IAEI;QACI,WAAW;QACX,YAAY;;IAEhB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,8DAA8D;QAC9D,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;;IAEpB;;IAEA;QACI,yDAAgE;QAChE,2BAA2B;QAC3B,4BAA4B;QAC5B,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;QACV,WAAW;;IAEf;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;;IAEvB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,oBAAoB;IACxB;;;AAGJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;;AAGJ","sourcesContent":[".VatepayCrad_main_container{\n    background-color: #2F4604;\n    /* padding: 0 50px; */\n}\n.VatepayLTDCrad_partnershipbgImg_container{\n    position: absolute;\n    right: 0;\n}\n\n.VatepayCrad_container{\n    display: grid;\n    grid-template-columns: repeat(10,1fr);\n    gap: 30px;\n    padding: 160px 50px;\n    overflow: scroll;\n    scrollbar-width: none;\n}\n  \n.VatepayCrad_container::-webkit-scrollbar {\n    width: 0;\n}\n  \n.VatepayCrad_container::-webkit-scrollbar-thumb {\n    background-color: transparent;\n}\n\n.mdVatepayCrad{\n    background: linear-gradient(180deg, #012D01 65%, #EAAD11 130%);\n    width: 367px;\n    height: 356px;\n    border-radius: 15px;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n}\n\n.mdVatepayCrad_menu_container{\n    background-image: url('../Assets/Images/vatepay-md-menu-bg.svg');\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 80px;\n    height: 70px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: -10px;\n    right: -3px;\n}\n\n.vatepaycardmenu_img{\n    height: 28px;\n    width: 28px;\n}\n\n.mdVatepayCrad_img{\n    padding: 20px 0;\n}\n\n.mdVatepayCrad_img img{\n    width: 69px;\n    height: 69px;\n    border-radius: 100%;\n    object-fit: cover;\n}\n\n.mdVatepayCrad_column2{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.mdVatepayCradh3{\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24.46px;\n    /* width: 188px; */\n    height: 24px;\n    padding-bottom: 5px;\n    \n}\n\n.mdVatepayCradh5{\n    width: 100px;\n    height: 21px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21.41px;\n    color: #5CBF14;\n    padding-bottom: 50px;\n}\n\n.vatepay3_star{\n    width: 132px;\n    height: 20px;\n    padding-bottom: 50px;\n}\n\n.mdVatepayCradp{\n    width: 235px;\n    height: 84px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21.41px;\n}\n\n\n/* responsiveness starts here */\n@media screen and (max-width: 900px){\n    \n    .mdVatepayCrad_menu_container{\n        width: 50px;\n        height: 50px;\n        \n    }\n    \n    .vatepaycardmenu_img{\n        height: 23px;\n        width: 23px;\n    }\n    \n    .mdVatepayCrad_img img{\n        width: 69px;\n        height: 69px;\n        border-radius: 69px;\n    }\n    \n    .mdVatepayCradh3{\n        font-size: 14px;\n        \n    }\n    \n    .mdVatepayCradh5{\n        font-size: 12px;\n    }\n    \n    .vatepay3_star{\n        width: 130px;\n        height: 20px;\n        padding-bottom: 50px;\n    }\n    \n    .mdVatepayCradp{\n        width: 180px;\n        font-size: 10px;\n    }\n    \n}\n\n@media screen and (max-width: 500px){\n    .VatepayCrad_main_container{\n        background-color: #2F4604;\n        padding: 0 20px;\n    }\n    \n    .VatepayCrad_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 30px;\n        padding: 60px 20px;\n    }\n    \n    .mdVatepayCrad{\n        background: linear-gradient(180deg, #012D01 65%, #EAAD11 130%);\n        width: 100%;\n        height: 356px;\n        border-radius: 15px;\n        text-align: center;\n        position: relative;\n        overflow: hidden;\n    \n    }\n    \n    .mdVatepayCrad_menu_container{\n        background-image: url('../Assets/Images/vatepay-md-menu-bg.svg');\n        background-position: center;\n        background-repeat: no-repeat;\n        width: 80px;\n        height: 70px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        top: -10px;\n        right: -3px;\n        \n    }\n    \n    .vatepaycardmenu_img{\n        height: 28px;\n        width: 28px;\n    }\n    \n    .mdVatepayCrad_img{\n        padding: 20px 0;\n    }\n    \n    .mdVatepayCrad_column2{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    \n    .mdVatepayCradh3{\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24.46px;\n        /* width: 188px; */\n        height: 24px;\n        padding-bottom: 5px;\n        \n    }\n    \n    .mdVatepayCradh5{\n        width: 100px;\n        height: 21px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21.41px;\n        color: #5CBF14;\n        padding-bottom: 50px;\n    }\n    \n    .vatepay3_star{\n        width: 132px;\n        height: 20px;\n        padding-bottom: 50px;\n    }\n    \n    .mdVatepayCradp{\n        width: 235px;\n        height: 84px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21.41px;\n    }\n\n\n}\n\n@media screen and (max-width: 330px){\n      \n    .mdVatepayCradh3{\n        font-size: 14px;\n    }\n    \n    .mdVatepayCradh5{\n        font-size: 12px;\n    }\n    \n    .mdVatepayCradp{\n        width: 210px;\n        font-size: 12px;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
